import React from "react";
import BrandValue from "web/react/components/brand-value/brand-value";
import FeaturedBanners from "web/react/components/featured-banners/featured-banners";
import HomepageDesignerRail from "web/react/components/homepage-designer-rail/homepage-designer-rail";
import HomepageProductRail from "web/react/components/homepage-product-rail/homepage-product-rail";
import ProductTypeIndex from "web/react/components/product-type-index/product-type-index";
import SaleLandingHeader from "web/react/components/sale-landing-header/sale-landing-header";
import SaleLandingPageCategoriesRail from "web/react/components/sale-landing-page-categories-rail/sale-landing-page-categories-rail";
import SaleLandingPageLink from "web/react/components/sale-landing-page-link/sale-landing-page-link";
import SaleLandingPagePromoBanner from "web/react/components/sale-landing-page-promo-banner/sale-landing-page-promo-banner";
import { languageIsEnglish } from "web/script/modules/language";
import styles from "./sale-landing-page-layout.module.css";

interface SaleLandingPageLayoutProps {
    layoutData: any;
}

export function SaleLandingPageLayout({
    layoutData: {
        header_title: headerTitle,
        sale_promo_banner: promoBanner,
        sale_page_categories: categories,
        sale_page_designers: designers,
        product_type_index: productIndex,
        opposite_gender_link: oppositeGenderLink,
        sale_page_offers: offersOfTheWeek,
        sale_page_featured_banners: featuredBanners,
        brand_values: brandValues,
    },
}: SaleLandingPageLayoutProps): JSX.Element {
    const isEng = languageIsEnglish();

    return (
        <div className={styles.main}>
            {!promoBanner && <SaleLandingHeader title={headerTitle} />}
            {promoBanner && <SaleLandingPagePromoBanner {...promoBanner} />}
            {productIndex && <ProductTypeIndex links={productIndex.links} />}
            {designers && (
                <HomepageDesignerRail
                    items={designers.links}
                    analyticsLabel={"sale_landing_page_designers_rail"}
                />
            )}
            {categories && <SaleLandingPageCategoriesRail items={categories.links} />}
            {oppositeGenderLink && (
                <div className={styles.oppositeGenderLinkWrapper}>
                    <SaleLandingPageLink item={oppositeGenderLink} type={"opposite-gender"} />
                </div>
            )}
            {offersOfTheWeek && offersOfTheWeek.products.length && (
                <HomepageProductRail
                    title={offersOfTheWeek.title}
                    products={offersOfTheWeek.products}
                />
            )}
            {isEng && brandValues && <BrandValue className={styles.brandValues} {...brandValues} />}
            {featuredBanners && <FeaturedBanners {...featuredBanners} />}
        </div>
    );
}

export default SaleLandingPageLayout;
